<template>
  <div class="Invoice">
    <div class="page-title">{{ $t("title.buy_invoice") }}</div>

    <div class="flex">
      <div class="lt-area flex-auto">
        <el-input
          class="input-with-select"
          size="mini"
          v-model="searchWord"
          clearable
          :placeholder="searchPlaceHolder"
          style="width: 300px;"
          @keydown.enter.native="handleClickFilter"
        >
          <el-button slot="append" icon="el-icon-search" @click="handleClickFilter" />
        </el-input>

        <div class="right-search-head inline" style="margin-left: 10px">
          <div class="inline">
            <APeriodSelector 
              ref="period" 
              :value="search_period" 
              hide-select
              @change="handleChangePeriod" 
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
            >검색(F5)</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="row-splitter">
      <div class="list-title">
        <h3>세금계산서 미 수취 리스트</h3>
      </div>
      <ATable
        ref="table_customer"
        max-height="322px"
        v-loading="loading_contract"
        :data="tableDataContract"
        hide-top-panel
        hide-button-insert
        hide-pagination
        highlight-current-row
        border
        @current-change="currentChange"
      >
        <el-table-column
          type="index"
          label="No"
          :index="handleIndex"
          :width="$width.indexw"
        />
        <el-table-column
          prop="name"
          label="거래처"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="location"
          label="사업장"
          min-width="120"
          show-overflow-tooltip
        />

        <el-table-column
          prop="unpaid_price"
          label="매입금 총합"
          class-name="cell-number"
          width="100"
          :formatter="util.numberFormat"
        />

        <el-table-column
          prop="published_price"
          class-name="cell-number"
          label="결제금 합계"
          width="100"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="unpublished_price"
          label="세금계산서 미수취"
          width="150"
          class-name="cell-number"
          :formatter="util.numberFormat"
        />

        <el-table-column
          prop="status_flag"
          label="상태"
          width="50"
        >
          <template slot-scope="scope">{{scope.row.unpublished_price ? '진행' : '완료'}}</template>
        </el-table-column>
      </ATable>
    </div>
    <div class="row-splitter">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-input placeholder="거래처" v-model="customer.name" readonly>
            <template slot="prepend">거래처</template>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="사업장" v-model="customer.location" readonly>
            <template slot="prepend">사업장</template>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input placeholder="미수취" :value="customer.unpublished_price | number" readonly>
            <template slot="prepend">미수취</template>
          </el-input>
        </el-col>
      </el-row>
    </div>

    <div class="row-splitter">
      <div class="list-title">
        <h3>세금 계산서 수취 여부 체크 리스트</h3>
      </div>
      <ATable
        ref="table_sale"
        v-loading="loading_sale"
        buttons-width="350px"
        max-height="250"
        :data="tableDataSale"
        :default-sort="{prop: 'code', order: 'ascending'}"
        hide-top-panel
        hide-button-insert
        hide-pagination
        border
        @selection-change="saleSelectionChange"
        @row-click="handleBillRowClick"
      >
        <el-table-column 
          type="selection" 
          label="선택" 
          align="center" 
          :width="$width.selection" 
        />
        <el-table-column
          type="index"
          label="No"
          :index="handleIndexSale"
          :width="$width.indexw"
        />
        <el-table-column
          prop="issue_date"
          label="계산서 수취일"
          width="120"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="approval_number"
          label="수취 여부"
          width="80"
          :formatter="(a,b,c) => c ? '수취' : '미수취'"
        />

        <el-table-column
          prop="price"
          label="계산서 수취금액"
          class-name="cell-number"
          width="120"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="status_flag"
          label="상태"
          class-name="cell-number"
          width="80"
        >
          <template slot-scope="scope">{{scope.row.approval_number ? '수취' : '미수취'}}</template>
        </el-table-column>
        <el-table-column
          prop="created_user_name"
          label="등록자"
          :width="$width.username"
        />
        <el-table-column
          prop="approval_number"
          label="계산서 수취 번호"
          min-width="200"
        />
        <div slot="buttons">
          <el-button 
            type="primary" 
            :disabled="!has_grant_write"
            @click="handleBillCreat"
          >계산서 등록</el-button>
          <el-button
            type="danger"
            :disabled="saleSelection.length < 1 || !has_grant_write"
            @click="handleClickCancel"
          >계산서 취소</el-button>
          <el-button
            type="primary"
            :disabled="saleSelection.length < 1"
            @click="handleClickPrint"
          >세금계산서 미리보기</el-button>
        </div>
      </ATable>
    </div>

    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="세금 계산서 등록/수정"
      :visible.sync="dialogVisible"
      destroyOnClose
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <InvoiceForm ref="form" :customer="customer" :data="form_data" @completed="handleCompleted" />
    </el-dialog>

    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="세금 계산서 미리보기"
      width="900px"
      :visible.sync="dialogVisiblePrint"
      destroyOnClose
      :close-on-click-modal="false"
    >
      <invoice-print-form ref="invoice_print" :data="customer" :details="saleSelection" />
    </el-dialog>
  </div>
</template>
<script>
import APeriodSelector from "../../shared/APeriodSelector";
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import InvoiceForm from "./InvoiceForm";
import InvoicePrintForm from "./InvoicePrintForm";

export default {
  name: "Invoice",
  mixins: [form_container, authority_level],
  components: { InvoicePrintForm, APeriodSelector, InvoiceForm },
  data() {
    return {
      title: this.$t('title.invoice'),
      period: {},
      search_period: {value: '0d'},
      searchPlaceHolder: "거래처, 사업장",
      search_field: ["name", "location"],
      search_fieldSale: ["name", "location"],
      searchWord: null,
      fixedSearchWord: "",

      pageSize: 10,

      currentPageContract: 1,
      currentPageSale: 1,

      loading_contract: false,
      items_contract: [],
      contractSelection: [],

      customer: {
        id: 0,
        name: "거래처",
        /*customer_id: 0,
                    customer_name: '거래처',*/
        location: "사업장",
        // price: 10000,
        unpublished_price: null
      },

      transaction_id: "",
      loading_sale: false,
      items_sale: [],
      saleSelection: [],
      dialogVisible: false,
      form_data: undefined,

      dialogVisiblePrint: false
    };
  },
  computed: {
    /* 발주 */
    filterDataContract: function() {
      let items = this.items_contract;
      items = this.util.filterMultiFields(
        items,
        this.search_field,
        this.fixedSearchWord
      );
      return items;
    },
    recordCountContract() {
      return this.filterDataContract.length;
    },
    tableDataContract() {
      return this.filterDataContract;
    },

    /* 계산서 */
    filterDataSale: function() {
      return this.items_sale;
    },
    recordCountSale() {
      return this.filterDataSale.length;
    },
    tableDataSale() {
      return this.filterDataSale;
    },
    has_grant_write() {
      return this.isWriteLevel('buy_invoice');
    },
  },
  mounted() {
    this.$nextTick(() => this.handleClickSearch());
  },
  methods: {
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.currentPageContract = 1;
      this.currentPageSale = 1;
      this.loadData();
    },
    handleClickFilter() {
      this.currentPageContract = 1;
      this.currentPageSale = 1;
      this.fixedSearchWord = this.searchWord;
      this.selectFirstCustomer();
    },

    selectFirstCustomer(id) {
      this.$nextTick(() => {
        let table = this.$refs.table_customer;
        let data = table.data;
        if (data) {
          let row = data.find(item => item.id === id);
          setTimeout(() => {
            table.setCurrentRow(id ? row : data[0]);
          }, 100);
        }
      });
    },

    loadData(id) {
      this.loading_contract = true;
      this.api.statInboundBill(this.period).then(res => {
        this.loading_contract = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, this.title, res.message);
          return;
        }

        this.items_contract = res.data;

        this.selectFirstCustomer(id);
      });
    },

    currentChange(currentRow) {
      this.customer = currentRow ? currentRow[0] : {};
      this.loadBill();
    },

    loadBill() {
      let customer_id = this.customer.id;

      if (!customer_id) {
        this.items_sale = [];
        return;
      }

      this.api.listBill(customer_id).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, this.title, res.message);
          return;
        }

        this.items_sale = res.data;
      });
    },

    handleBillRowClick(data) {
      this.openDialog(data);
    },
    handleBillCreat() {
      this.form_data = undefined;
      this.openDialog();
    },

    handleClickCancel() {
      if (this.saleSelection.length < 1) {
        this.util.notify(
          this,
          "w",
          this.$t("title.invoice"),
          this.$t("message.no_selection")
        );
        return;
      }

      /** 취소 */
      return this.$confirm("취소하시겠습니까?", this.title, {
        type: "warning",
        confirmButtonText: "네",
        cancelButtonText: "아니오"
      })
        .then(() => {
          this.doDelete();
        })
        .catch(() => {});
    },
    doDelete() {
      let params = this.saleSelection.map(item => item.id);
      this.api.cancelBill(params).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_error(
            this,
            this.title,
            res.message
          );
          return;
        }

        let id = this.customer.id;
        this.loadData(id);
        this.currentPageSale = 1;
        // this.loadBill();
      });
    },

    handleClickPrint() {
      this.dialogVisiblePrint = true;
    },

    handleCompleted(action, message) {
      this.dialogVisible = false;
      this.form_data = undefined;

      let id = this.customer.id;

      switch (action) {
        case "create":
        case "delete":
          this.loadData(id);

          this.currentPageSale = 1;
          // this.loadBill();
          break;
        case "update":
          this.loadData(id);
          // this.loadBill();
          break;
      }
      if (!message) {
        return;
      }
      this.$notify(message);
    },
    openDialog(data) {
      let clone = data ? Object.assign({}, data) : undefined;

      this.form_data = clone;
      this.dialogVisible = true;
    },

    contractSelectionChange(selection) {
      this.contractSelection = selection;
    },
    saleSelectionChange(selection) {
      this.saleSelection = selection;
    },
    handleCurrentChangeContract(value) {
      this.currentPageContract = value;
    },
    handleCurrentChangeSale(value) {
      this.currentPageSale = value;
    },

    handleIndex(index) {
      return (
        this.recordCountContract -
        (this.currentPageContract - 1) * this.pageSize -
        index
      );
    },
    handleIndexSale(index) {
      // return this.recordCountSale - ((this.currentPageSale - 1) * this.pageSize) - index;
      return this.recordCountSale - index;
    }
  }
};
</script>
<style lang="scss" scoped>
.search-keyword {
  width: 300px;
  margin-right: 20px;
}

.search-status {
  width: 200px;
  margin-right: 20px;
}
</style>
